<script lang="ts">
  import Form from "../ui/Form.svelte"
  import {
    Milestone,
    isFixed,
    formatPercentage,
    validateMilestone,
    isSolePersistedPercentageMilestone,
    toggleType,
  } from "@models/milestones/Milestone"
  import { formatISO, parseISO } from "date-fns"
  import { post, put } from "@util/api"
  import AmountInput from "@components/ui/AmountInput.svelte"
  import ErrorMessage from "@components/ui/ErrorMessage.svelte"
  import MilestoneLabel from "./MilestoneLabel.svelte"
  export let milestone: Milestone
  export let milestones: Milestone[]
  export let path: string
  export let registrationClosesOn: string

  async function submit() {
    let result
    if (milestone.id) {
      result = await put(path, { milestone })
    } else {
      result = await post(path, { milestone })
    }

    if (result.ok) {
      milestone = { ...result.body.data.milestoneDate, isEditing: false }
    }

    return result
  }

  function setDateValue(e) {
    // the date-picker-with-presets component has a hidden date and an internal input
    // we want to grab the value of the hidden input not the internal input which
    // is used purely for display purposes
    if (e.target.dataset.role !== "internal-input") {
      let date = e.target.value
      milestone.date = date && formatISO(parseISO(date), { representation: "date" })
    }
  }
</script>

<Form data={milestone} validate={validateMilestone} {submit} let:submitted let:submitting let:errors>
  <div data-role={`milestone-edit-${milestone.id}`} class="pl-4 py-1 grid grid-cols-7 gap-4 items-start" data-path={path}>
    <div class="col-span-2" class:mt-2={milestone.isEditing}>
      <MilestoneLabel {milestones} {milestone} />
    </div>
    {#if isSolePersistedPercentageMilestone(milestones, milestone)}
      <div />
    {:else}
      <select data-role="milestone-type" value={milestone.type} on:change={() => (milestone = toggleType(milestone))}>
        <option value="fixed">$</option>
        <option value="percentage">%</option>
      </select>
    {/if}
    <div class="">
      {#if isFixed(milestone)}
        <AmountInput name="amount" bind:value={milestone.amount} />
      {:else}
        <div class="mt-2 px-4">{formatPercentage(milestones)}%</div>
      {/if}
      <ErrorMessage when={submitted} error={errors.amount} />
    </div>
    <div class="col-span-2" data-role="milestone-date">
      <date-picker-with-presets
        value={milestone.date}
        label="When registration ends"
        relative-to-date={registrationClosesOn}
        on:change={(e) => {
          setDateValue(e)
        }}
        is-valid={errors.date === undefined} />
      <ErrorMessage when={submitted} error={errors.date} />
    </div>
    <button>Save</button>
  </div>
</Form>
